import { SignIdentity } from "@icp-sdk/core/agent";
import { DelegationChain, DelegationIdentity, ECDSAKeyIdentity } from "@icp-sdk/core/identity";
export async function buildIdentityFromJson(json) {
    const key = await ECDSAKeyIdentity.fromKeyPair(json.key);
    const delegationChain = DelegationChain.fromJSON(json.delegation);
    return DelegationIdentity.fromDelegation(key, delegationChain);
}
export function buildDelegationChain(userKey, delegation, signature) {
    const delegations = [
        {
            delegation,
            signature,
        },
    ];
    return DelegationChain.fromDelegations(delegations, userKey);
}
export function buildDelegationIdentity(userKey, sessionKey, delegation, signature) {
    const delegationChain = buildDelegationChain(userKey, delegation, signature);
    return DelegationIdentity.fromDelegation(sessionKey, delegationChain);
}
export function toDer(key) {
    return key.getPublicKey().toDer();
}
